import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");

    if (!token) {
        return <Navigate to="/" />;
    }

    try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000; // detik
        if (decoded.exp < now) {
            // expired → auto logout
            localStorage.removeItem("token");
            return <Navigate to="/" />;
        }
    } catch (err) {
        localStorage.removeItem("token");
        return <Navigate to="/" />;
    }

    return children;
};

export default ProtectedRoute;
